/**
 * Returns true if `current` is strictly below `minimum`.
 * Compares major.minor.patch numerically.
 */
export function isVersionBelowMinimum(
  current: string,
  minimum: string
): boolean {
  const parse = (v: string) => v.split(".").map(Number);
  const [curMajor = 0, curMinor = 0, curPatch = 0] = parse(current);
  const [minMajor = 0, minMinor = 0, minPatch = 0] = parse(minimum);

  if (curMajor !== minMajor) return curMajor < minMajor;
  if (curMinor !== minMinor) return curMinor < minMinor;
  return curPatch < minPatch;
}
